// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const addMutation = graphql`
	mutation UserAddMutation($input: UserAddInput!) {
		UserAdd(input: $input) {
            error
			userEdge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: addMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const {error, userEdge} = response.UserAdd;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, userEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/UserAddMutation.js